// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyPlaceholderView_wrapper__WjYxP"};